<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex sm6>
        <div class="headline green--text text--darken-4 font-weight-medium">
          Patients
        </div>
      </v-flex>
      <v-flex xs12 sm12 lg12>
        <v-layout>
          <v-btn color="primary" v-show="allowAddEdit" @click="showAddDlg">
            <v-icon class="iconText">fa fa-plus</v-icon>
            New Patient
          </v-btn>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm12 lg12>
        <v-layout row wrap>
          <div class="filterStyle">
            <v-text-field label="Patient Id:" v-model="searchModel.pid">
              <template slot="prepend">
                <v-icon class="filterIcon grey--text text--darken-1"
                  >fa fa-filter</v-icon
                >
              </template>
            </v-text-field>
          </div>
          <div class="filterStyle">
            <v-text-field label="Name:" v-model="searchModel.name">
              <template slot="prepend">
                <v-icon class="filterIcon grey--text text--darken-1"
                  >fa fa-filter</v-icon
                >
              </template>
            </v-text-field>
          </div>
          <div class="filterStyle">
            <v-text-field label="Mobile:" v-model="searchModel.mobile">
              <template slot="prepend">
                <v-icon class="filterIcon grey--text text--darken-1"
                  >fa fa-filter</v-icon
                >
              </template>
            </v-text-field>
          </div>
          <div class="filterStyle">
            <v-text-field
              :disabled="allowAddEdit"
              label="Doctor Name:"
              v-model="searchModel.docname"
            >
              <template slot="prepend">
                <v-icon class="filterIcon grey--text text--darken-1"
                  >fa fa-filter</v-icon
                >
              </template>
            </v-text-field>
          </div>
          <v-flex>
            <v-btn color="primary" :disabled="loading" @click="api_get">
              <v-icon class="iconText">fa fa-search</v-icon>
              Search
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap> </v-layout>
      </v-flex>
      <v-flex xs12 sm12 lg12>
        <v-card>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="patients"
              item-key="Id"
              :rows-per-page-items="rows_per_page"
              :loading="loading"
              :pagination.sync="pagination"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{ props.item.PatientId }}</td>
                  <td>{{ props.item.Name }}</td>
                  <td>{{ props.item.Mobile }}</td>
                  <td>{{ props.item.Address }}</td>
                  <td style="text-align: center">
                    <!--<button-->
                    <!--class="linkBtn"-->
                    <!--type="button"-->
                    <!--@click="showView(props.item)"-->
                    <!--&gt;-->
                    <!--View-->
                    <!--</button>-->
                    <button
                      class="linkBtn"
                      type="button"
                      v-show="allowAddEdit"
                      @click="showEditDlg(props.item)"
                    >
                      Edit
                    </button>
                    <button
                      class="linkBtn"
                      type="button"
                      v-show="allowDelete"
                      @click="showDeleteDlg(props.item)"
                    >
                      Delete
                    </button>
                    <button
                      class="linkBtn"
                      type="button"
                      v-show="allowAddEdit"
                      @click="showView(props.item)"
                    >
                      Create Prescription
                    </button>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <div>
              <v-dialog
                v-model="dlgShow"
                scrollable
                persistent
                max-width="400px"
              >
                <v-card>
                  <v-card-title>
                    <div class="title font-weight-medium">
                      {{ dlgTitle }}
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      v-model.trim="dlgModel.Name"
                      name="fName"
                      label="Full Name:"
                      :disabled="dlgType !== 0"
                      v-validate="{ required: true }"
                      :error="!!errors.has('fName')"
                      :error-messages="errors.first('fName')"
                    ></v-text-field>
                    <v-text-field
                      v-model.trim="dlgModel.Email"
                      name="email"
                      label="Email:"
                    ></v-text-field>
                    <v-text-field
                      v-model.trim="dlgModel.Mobile"
                      name="mobile"
                      label="Mobile Number:"
                      v-validate="{ required: true }"
                      :error="!!errors.has('mobile')"
                      :error-messages="errors.first('mobile')"
                    ></v-text-field>
                    <v-textarea
                      v-model.trim="dlgModel.Address"
                      name="address"
                      label="Address:"
                      v-validate="{ required: true }"
                      :error="!!errors.has('address')"
                      :error-messages="errors.first('address')"
                      no-resize
                      rows="2"
                    ></v-textarea>
                    <v-text-field
                      v-model.trim="dlgModel.PatientId"
                      name="patientId"
                      label="Patient Id:"
                      v-validate="{ required: true }"
                      :error="!!errors.has('patientId')"
                      :error-messages="errors.first('patientId')"
                    ></v-text-field>
                    <v-text-field label="Age:" v-model.number="dlgModel.Age">
                    </v-text-field>
                    <v-autocomplete
                      :items="genders"
                      v-model="dlgModel.Gender"
                      label="Gender:"
                      name="gender"
                      item-text="Text"
                      item-value="Id"
                      v-validate="{ required: true }"
                      :error="!!errors.has('gender')"
                      :error-messages="errors.first('gender')"
                    >
                    </v-autocomplete>
                    <!--<v-checkbox v-model="dlgModel.Married" label="Married">-->
                    <!--</v-checkbox>-->
                    <!--<v-text-field-->
                    <!--v-model.number="dlgModel.NoOfMonthsCourse"-->
                    <!--label="No. of months since course started:"-->
                    <!--:disabled="dlgType !== 0"-->
                    <!--&gt;</v-text-field>-->
                    <v-text-field
                      v-model.number="dlgModel.SlitConsumed"
                      label="No. of SLITs consumed:"
                      :disabled="dlgType !== 0"
                    ></v-text-field>
                    <div v-show="submit.error">
                      <v-list two-line>
                        <v-list-tile>
                          <span class="red--text">{{ submit.message }}</span>
                        </v-list-tile>
                      </v-list>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      :disabled="submit.working"
                      @click.native="clearDlg"
                      >Close</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      flat
                      :loading="submit.working"
                      @click.native="saveDlg"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import WebH from "../../api/web";
export default {
  created() {
    this.allowAddEdit = this.$store.getters["UserStore/permissions"].includes(
      "pat.a"
    );
    this.allowDelete = this.$store.getters["UserStore/permissions"].includes(
      "pat.r"
    );
  },
  data() {
    return {
      allowAddEdit: false,
      allowDelete: false,
      genders: [
        { Id: 0, Text: "Male" },
        { Id: 1, Text: "Female" },
        { Id: 2, Text: "Others" }
      ],
      rows_per_page: [25, 50],
      pagination: { sortBy: "PatientId", descending: true },
      headers: [
        {
          text: "Patient Id",
          value: "PatientId",
          sortable: true,
          width: "10%"
        },
        { text: "Name", value: "Name", sortable: true, width: "20%" },
        { text: "Mobile", value: "Mobile", sortable: true, width: "10%" },
        {
          text: "Address",
          value: "Address",
          sortable: true,
          width: "20%"
        },
        {
          text: "Actions",
          value: "",
          sortable: false,
          width: "20%",
          align: "center"
        }
      ],
      patients: [],
      loading: false,
      dlgShow: false,
      dlgType: 0,
      dlgModel: {},
      dlgTitle: "",
      submit: {
        error: false,
        working: false,
        message: ""
      },
      searchModel: {
        name: "",
        pid: "",
        mobile: "",
        docname: ""
      }
    };
  },
  methods: {
    clearDlg() {
      this.submit = {
        error: false,
        completed: false,
        message: ""
      };
      this.dlgShow = false;
    },
    showAddDlg() {
      this.dlgTitle = "New Patient";
      this.dlgType = 0;
      this.dlgModel = {
        Name: "",
        Age: "",
        Email: "",
        Mobile: "",
        Address: "",
        PatientId: "",
        Gender: "",
        // Married: false,
        SlitConsumed: 0
      };
      this.dlgShow = true;
    },
    showEditDlg(item) {
      this.dlgTitle = "Update Patient";
      this.dlgType = 1;
      this.dlgModel = item;
      //this.dlgModel.Age = item.Age;
      this.dlgShow = true;
    },
    async showDeleteDlg(item) {
      const res = await this.$notifyDlg.show(
        "Do you really want delete this patient?",
        "Delete patient",
        "warning",
        true
      );
      if (res) {
        this.api_DeletePatient(item);
      }
    },
    async showView(item) {
      const data = {
        patients: this.patients
      };
      await this.$store.dispatch("PatientsStore/setData", data);
      this.$router.push({
        name: "patients/cp",
        params: { patient: item }
      });
    },
    async saveDlg() {
      const res = await this.$validator.validateAll();
      if (!res) return;
      this.submit.working = true;
      if (this.dlgType === 0) {
        const newItem = this.dlgModel;
        // newItem.Gender = this.$options.filters.genderStrInt(
        //   this.dlgModel.Gender
        // );
        this.api_newPatient(newItem);
      } else if (this.dlgType === 1) {
        const newData = {
          Id: this.dlgModel.Id,
          PatientId: this.dlgModel.PatientId,
          Mobile: this.dlgModel.Mobile,
          Address: this.dlgModel.Address,
          Email: this.dlgModel.Email,
          Gender: this.dlgModel.Gender,
          //Married: this.dlgModel.Married,
          Age: this.dlgModel.Age
        };
        this.api_editPatient(newData);
      }
    },
    async api_newPatient(data) {
      const res = await WebH.Post("/patients", data);
      this.submit.working = false;
      if (res.Success) {
        this.patients.push(res.Data);
        this.$notify({ type: "info", text: "Successfully added new patient" });
        this.clearDlg();
      } else {
        this.submit.error = true;
        this.submit.message = res.Data;
      }
    },
    async api_editPatient(data) {
      const res = await WebH.Put("/patients/" + data.Id, data);
      this.submit.working = false;
      if (res.Success) {
        this.$notify({
          type: "info",
          text: "Successfully updated the patient"
        });
        this.clearDlg();
      } else {
        this.submit.error = true;
        this.submit.message = res.Data;
      }
    },
    async api_DeletePatient(data) {
      this.submit.working = true;
      const res = await WebH.Delet("/patients/" + data.Id);
      this.submit.working = false;
      if (res.Success) {
        const index = this.patients.indexOf(data);
        if (index > -1) {
          this.patients.splice(index, 1);
        }
        this.$notify({
          type: "info",
          text: "Successfully deleted the patient"
        });
        this.clearDlg();
      } else {
        await this.$notifyDlg.show(res.Data, "Error", "error");
      }
    },
    async api_get() {
      this.loading = true;
      this.patients = [];
      let url = "/patients/search?";
      if (!this.allowAddEdit) url = "/patients/search_all?";
      url += "name=" + this.searchModel.name;
      url += "&pid=" + this.searchModel.pid;
      url += "&mobile=" + this.searchModel.mobile;
      if (!this.allowAddEdit) url += "&docname=" + this.searchModel.docname;
      // let url = "";
      // if (this.$store.getters["UserStore/permissions"].includes("pata.v"))
      //   url = "/patients/all";
      // else url = "/patients";
      const res = await WebH.Get(url, "patients");
      if (res.Success) {
        this.patients = res.Data;
      }
      this.loading = false;
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === "patients/cp") {
      next(vm => {
        vm.patients = vm.$store.getters["PatientsStore/patients"];
      });
    } else
      next(vm => {
        vm.api_get();
      });
  }
};
</script>

<style scoped>
.filterStyle {
  padding: 12px;
  flex: 0 0 21%;
}
</style>
